import { Box, Skeleton, Typography } from '@mui/material';
import { FaArrowLeft } from 'react-icons/fa';

export default function IntegrationSkeleton() {
  return (
    <>
      {/* Back Button Skeleton */}
      <Typography sx={{ cursor: 'pointer', alignItems: 'center' }} mb={2}>
        <FaArrowLeft /> Back to All apps
      </Typography>

      {/* Integration Card Skeleton */}
      <Box bgcolor='white' p={3}>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Box>
            {/* Integration Avatar Skeleton */}
            <Skeleton variant='rectangular' width={80} height={80} sx={{ borderRadius: 1 }} />

            {/* Description Skeleton */}
            <Skeleton variant='text' width={300} height={20} sx={{ my: 1 }} />
            <Skeleton variant='text' width={250} height={20} />
          </Box>

          {/* Configure Button Skeleton */}
          <Skeleton variant='rectangular' width={100} height={40} sx={{ borderRadius: 1 }} />
        </Box>
      </Box>
    </>
  );
}
